import { createContext, useContext, useState } from "react";

import {
  imageFive,
  imageFour,
  imageOne,
  imageSix,
  imageThree,
  imageTwo,
} from "../../utils/imagesUrl";

export const ProductsContext = createContext([]);

export const ProductsProvider = ({ children }) => {
  const [products] = useState([
    {
      name: "Telefone Nelphone Lord",
      price: 279.99,
      image: imageOne,
    },
    {
      name: "TV Westinghouse",
      price: 499.99,
      image: imageTwo,
    },
    {
      name: "Fita Cassete TDK",
      price: 19.99,
      image: imageThree,
    },
    {
      name: "Máquina de Escrever Remington",
      price: 399.99,
      image: imageFour,
    },
    {
      name: "Rádio Grundig",
      price: 289.99,
      image: imageFive,
    },
    {
      name: "Computador IBM 3174-11",
      price: 1799.99,
      image: imageSix,
    },
  ]);

  return (
    <ProductsContext.Provider value={{ products }}>
      {children}
    </ProductsContext.Provider>
  );
};

export const useProducts = () => useContext(ProductsContext);
